<template>
    <div class="toast">
      <p class="toast-text bold">{{ data.text }}</p>
    </div>
</template>
<script>
export default {
  name: 'toast',
  props: {
    data: {
      type: Object
    }
  },
  created () {
    setTimeout(() => {
      this.$el.parentNode.removeChild(this.$el)
      this.$destroy()
    }, 2100)
  }
}
</script>
<style scoped>
  .toast{
    width: 90%;
    max-width: 250px;
    border-radius: 30px;
    background-color: #333;
    color: #fff;
    text-align: center;
    padding: 10px 15px;
    position: fixed;
    z-index: 1000000000;
    left: 50%;
    transform: translateX(-50%);
    bottom: 50px;
    -webkit-animation: toastshow 0.3s, toasthide 0.3s 1.8s;
    animation: toastshow 0.3s, toasthide 0.3s 1.8s;
    box-shadow: 0 12px 16px -6px rgba(14,13,26,.12),0 10px 48px 8px rgba(7,48,114,.12),0 24px 38px 3px rgba(34,0,51,.04);
  }
  .toast-text{
    color: white;
    font-size: 1em;
  }
  @keyframes toastshow {
    from {bottom: 0; opacity: 0;}
    to {bottom: 50px; opacity: 1;}
  }
  @keyframes toasthide {
    from {bottom: 50px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
  }
</style>
